import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import {
  IMotivoDTO,
  IMotivoForm,
  IMotivoProps,
  IPageMotivoDTO,
} from "../../types/motivo";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/motivo";
export class Motivo {
  static async list(
    props?: IMotivoProps
  ): Promise<AxiosResponse<IPageMotivoDTO>> {
    let params = "";
    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }
    return ApiBrave.get(params ? `${basePath}?${params}` : basePath);
  }

  static async byId({
    uuid,
  }: {
    uuid: string;
  }): Promise<AxiosResponse<IMotivoDTO>> {
    return ApiBrave.get(`${basePath}/${uuid}`);
  }

  static async post(data: IMotivoForm): Promise<AxiosResponse<IMotivoDTO>> {
    return ApiBrave.post(basePath, data);
  }

  static async put(data: IMotivoDTO): Promise<AxiosResponse<IMotivoDTO>> {
    const { uuid, ...rest } = data;
    return ApiBrave.put(`${basePath}/${uuid}/atualizar`, rest);
  }
}
